import { isMngWorkShift } from "./mngHours";

const MAX_CONSECUTIVE_SHIFTS = 5;
const MIN_REST_HOURS = 12;

function workShiftBounds(shift, dayIndex) {
  const start = Number(shift.start);
  const end = Number(shift.end);
  if (Number.isNaN(start) || Number.isNaN(end)) return null;
  const dayStart = dayIndex * 24;
  return {
    startAt: dayStart + start,
    endAt: start > end ? dayStart + 24 + end : dayStart + end,
  };
}

export function consecutiveWorkShiftWarnings(shifts) {
  const list = shifts || [];
  const warnings = list.map(() => "");
  let run = 0;
  for (let i = 0; i < list.length; i += 1) {
    if (!isMngWorkShift(list[i])) {
      run = 0;
      continue;
    }
    run += 1;
    if (run > MAX_CONSECUTIVE_SHIFTS) {
      warnings[i] = `${run} смена подряд, максимум ${MAX_CONSECUTIVE_SHIFTS}`;
      run = 0;
    }
  }
  return warnings;
}

export function restGapWarnings(shifts) {
  const list = shifts || [];
  const warnings = list.map(() => "");
  const workDays = [];
  for (let i = 0; i < list.length; i += 1) {
    if (!isMngWorkShift(list[i])) continue;
    const bounds = workShiftBounds(list[i], i);
    if (!bounds) continue;
    workDays.push({ index: i, ...bounds });
  }
  for (let i = 1; i < workDays.length; i += 1) {
    const prev = workDays[i - 1];
    const next = workDays[i];
    const gap = next.startAt - prev.endAt;
    if (gap >= MIN_REST_HOURS) continue;
    const hours = Math.round(Math.max(0, gap) * 10) / 10;
    const text = `промежуток ${hours} ч, минимум ${MIN_REST_HOURS}`;
    warnings[prev.index] = text;
    warnings[next.index] = text;
  }
  return warnings;
}

export function employeeScheduleWarnings(shifts) {
  const streak = consecutiveWorkShiftWarnings(shifts);
  const rest = restGapWarnings(shifts);
  return streak.map((left, index) =>
    [left, rest[index]].filter(Boolean).join(". "),
  );
}
